import { BaseModel } from '@/api/base-model'
import { TypeformFormAPI } from '@/api/backend-client'
import { TypeformResponseAnswerChoice } from '@/api/model/typeform/typeform-response-answer-choice'

export class TypeformResponseAnswer extends BaseModel<TypeformResponseAnswer> {
    protected collectionName = TypeformFormAPI.collectionName

    constructor(
        public type: string,
        public choices: TypeformResponseAnswerChoice[],
        public fieldId: string,
        public fieldType: string,
        public text?: string,
        public number?: number,
        public date?: Date,
        public choicesOther?: string,
        public boolean?: boolean,
        public email?: string,
        public url?: string,
        public fileUrl?: string,
        public fieldRef?: string,
    ) { super(null) }

    get isFieldTypeText(): boolean {
        return [
            'short_text',
            'long_text',
            'dropdown',

        ].includes(this.fieldType)
    }

    get isFieldTypeChoice(): boolean {
        return [
            'multiple_choice',
            'picture_choice',

        ].includes(this.fieldType)
    }

    get isFieldTypeEmail(): boolean {
        return [
            'email',

        ].includes(this.fieldType)
    }

    get isFieldTypeUrl(): boolean {
        return [
            'website',
            'file_upload',

        ].includes(this.fieldType)
    }

    get isFieldTypeBoolean(): boolean {
        return [
            'legal',
            'yes_no',

        ].includes(this.fieldType)
    }

    get isFieldTypeNumber(): boolean {
        return [
            'rating',
            'opinion_scale',
            'number',

        ].includes(this.fieldType)
    }

    get isFieldTypeDate(): boolean {
        return [
            'date',

        ].includes(this.fieldType)
    }

    toRequestData(): any {
        return {
            type: this.type,
            choices: this.choices.map(entry => entry.toRequestData()),
            fieldId: this.fieldId,
            fieldType: this.fieldType,
            text: this.text,
            number: this.number,
            date: this.date,
            choicesOther: this.choicesOther,
            boolean: this.boolean,
            email: this.email,
            url: this.url,
            fileUrl: this.fileUrl,
            fieldRef: this.fieldRef,
        }
    }

    static fromData(data: any): TypeformResponseAnswer {
        if (data === null || typeof data === 'string' || data instanceof TypeformResponseAnswer) {
            return data
        }

        return new TypeformResponseAnswer(
            data.type,
            Object.values(data.choices || {}).map(entry => TypeformResponseAnswerChoice.fromData(entry)),
            data.fieldId,
            data.fieldType,
            data.text,
            data.number,
            data.date,
            data.choicesOther,
            data.boolean,
            data.email,
            data.url,
            data.fileUrl,
            data.fieldRef,
        )
    }
}
